import { FeelPopup } from './FeelPopup';
import { FeelPopupRenderer } from './FeelPopupRenderer';

export default {
  __init__: [ 'feelPopup', 'feelPopupRenderer' ],
  feelPopup: [ 'type', FeelPopup ],
  feelPopupRenderer: [ 'type', FeelPopupRenderer ],
};